import type { Role, Permission } from './types';

export const permissionTree: Permission[] = [
  {
    id: 'overview',
    name: '数据概览',
    actions: ['view'],
  },
  {
    id: 'users',
    name: '用户管理',
    children: [
      {
        id: 'users-list',
        name: '用户列表',
        actions: ['view', 'add', 'edit', 'delete', 'export'],
      },
    ],
  },
  {
    id: 'tenants',
    name: '租户管理',
    children: [
      {
        id: 'tenants-list',
        name: '租户列表',
        actions: ['view', 'add', 'edit', 'delete', 'export'],
      },
    ],
  },
  {
    id: 'resources',
    name: '资源管理',
    children: [
      {
        id: 'resources-servers',
        name: '服务器管理',
        actions: ['view', 'add', 'edit', 'delete'],
      },
      {
        id: 'resources-templates',
        name: '云电脑模板',
        actions: ['view', 'add', 'edit', 'delete'],
      },
      {
        id: 'resources-datacenters',
        name: '机房管理',
        actions: ['view', 'add', 'edit', 'delete'],
      },
      {
        id: 'resources-apps',
        name: '应用管理',
        actions: ['view', 'add', 'edit', 'delete'],
      },
    ],
  },
  {
    id: 'monitoring',
    name: '监测',
    children: [
      {
        id: 'monitoring-faults',
        name: '故障列表',
        actions: ['view', 'edit'],
      },
    ],
  },
  {
    id: 'products',
    name: '商品管理',
    children: [
      {
        id: 'products-list',
        name: '商品列表',
        actions: ['view', 'add', 'edit', 'delete', 'export'],
      },
      {
        id: 'products-disks',
        name: '数据盘商品',
        actions: ['view', 'add', 'edit', 'delete'],
      },
      {
        id: 'products-recharge',
        name: '充值管理',
        actions: ['view', 'add', 'edit', 'delete'],
      },
      {
        id: 'products-categories',
        name: '商品分类',
        actions: ['view', 'add', 'edit', 'delete'],
      },
    ],
  },
  {
    id: 'orders',
    name: '订单管理',
    children: [
      {
        id: 'orders-list',
        name: '订单列表',
        actions: ['view', 'edit', 'export'],
      },
      {
        id: 'orders-after-sales',
        name: '售后订单',
        actions: ['view', 'edit'],
      },
      {
        id: 'orders-config',
        name: '订单配置',
        actions: ['view', 'edit'],
      },
    ],
  },
  {
    id: 'points',
    name: '积分管理',
    children: [
      {
        id: 'points-operations',
        name: '积分操作列表',
        actions: ['view', 'add', 'export'],
      },
      {
        id: 'points-recharge',
        name: '积分充值',
        actions: ['view', 'add'],
      },
    ],
  },
  {
    id: 'user-resources',
    name: '用户资源',
    children: [
      {
        id: 'user-resources-cloud-pcs',
        name: '云电脑',
        actions: ['view', 'edit', 'delete'],
      },
      {
        id: 'user-resources-cloud-disks',
        name: '云硬盘',
        actions: ['view', 'edit', 'delete'],
      },
    ],
  },
  {
    id: 'terminals',
    name: '终端管理',
    children: [
      {
        id: 'terminals-venues',
        name: '场所管理',
        actions: ['view', 'add', 'edit', 'delete'],
      },
      {
        id: 'terminals-thin-clients',
        name: '瘦终端管理',
        actions: ['view', 'add', 'edit', 'delete'],
      },
    ],
  },
  {
    id: 'billing',
    name: '账单中心',
    children: [
      {
        id: 'billing-management',
        name: '账单管理',
        actions: ['view', 'export'],
      },
    ],
  },
  {
    id: 'permissions',
    name: '权限管理',
    children: [
      {
        id: 'permissions-roles',
        name: '角色管理',
        actions: ['view', 'add', 'edit', 'delete'],
      },
      {
        id: 'permissions-accounts',
        name: '账号管理',
        actions: ['view', 'add', 'edit', 'delete'],
      },
      {
        id: 'permissions-departments',
        name: '部门管理',
        actions: ['view', 'add', 'edit', 'delete'],
      },
    ],
  },
  {
    id: 'notifications',
    name: '消息通知',
    children: [
      {
        id: 'notifications-list',
        name: '通知列表',
        actions: ['view', 'add', 'edit', 'delete'],
      },
      {
        id: 'notifications-management',
        name: '通知管理',
        actions: ['view', 'edit'],
      },
      {
        id: 'notifications-records',
        name: '发送记录',
        actions: ['view', 'export'],
      },
    ],
  },
  {
    id: 'system',
    name: '系统设置',
    children: [
      {
        id: 'system-logs',
        name: '操作日志',
        actions: ['view', 'export'],
      },
      {
        id: 'system-config',
        name: '系统配置',
        actions: ['view', 'edit'],
      },
      {
        id: 'system-maintenance',
        name: '系统维护',
        actions: ['view', 'edit'],
      },
      {
        id: 'system-tasks',
        name: '定时任务管理',
        actions: ['view', 'add', 'edit', 'delete'],
      },
    ],
  },
];

export const mockRoles: Role[] = [
  {
    id: 1,
    name: '超级管理员',
    description: '拥有系统所有权限，可以管理所有功能模块',
    userCount: 3,
    permissions: ['overview', 'users-list:view', 'users-list:add', 'users-list:edit', 'users-list:delete', 'users-list:export', 'tenants-list:view', 'tenants-list:add', 'tenants-list:edit', 'tenants-list:delete', 'tenants-list:export', 'resources-servers:view', 'resources-servers:add', 'resources-servers:edit', 'resources-servers:delete', 'resources-templates:view', 'resources-templates:add', 'resources-templates:edit', 'resources-templates:delete', 'resources-datacenters:view', 'resources-datacenters:add', 'resources-datacenters:edit', 'resources-datacenters:delete', 'resources-apps:view', 'resources-apps:add', 'resources-apps:edit', 'resources-apps:delete', 'monitoring-faults:view', 'monitoring-faults:edit', 'products-list:view', 'products-list:add', 'products-list:edit', 'products-list:delete', 'products-list:export', 'products-disks:view', 'products-disks:add', 'products-disks:edit', 'products-disks:delete', 'products-recharge:view', 'products-recharge:add', 'products-recharge:edit', 'products-recharge:delete', 'products-categories:view', 'products-categories:add', 'products-categories:edit', 'products-categories:delete', 'orders-list:view', 'orders-list:edit', 'orders-list:export', 'orders-after-sales:view', 'orders-after-sales:edit', 'orders-config:view', 'orders-config:edit', 'points-operations:view', 'points-operations:add', 'points-operations:export', 'points-recharge:view', 'points-recharge:add', 'user-resources-cloud-pcs:view', 'user-resources-cloud-pcs:edit', 'user-resources-cloud-pcs:delete', 'user-resources-cloud-disks:view', 'user-resources-cloud-disks:edit', 'user-resources-cloud-disks:delete', 'terminals-venues:view', 'terminals-venues:add', 'terminals-venues:edit', 'terminals-venues:delete', 'terminals-thin-clients:view', 'terminals-thin-clients:add', 'terminals-thin-clients:edit', 'terminals-thin-clients:delete', 'billing-management:view', 'billing-management:export', 'permissions-roles:view', 'permissions-roles:add', 'permissions-roles:edit', 'permissions-roles:delete', 'permissions-accounts:view', 'permissions-accounts:add', 'permissions-accounts:edit', 'permissions-accounts:delete', 'permissions-departments:view', 'permissions-departments:add', 'permissions-departments:edit', 'permissions-departments:delete', 'notifications-list:view', 'notifications-list:add', 'notifications-list:edit', 'notifications-list:delete', 'notifications-management:view', 'notifications-management:edit', 'notifications-records:view', 'notifications-records:export', 'system-logs:view', 'system-logs:export', 'system-config:view', 'system-config:edit', 'system-maintenance:view', 'system-maintenance:edit', 'system-tasks:view', 'system-tasks:add', 'system-tasks:edit', 'system-tasks:delete'],
    status: true,
    createdAt: '2024-01-15 10:30:25',
  },
  {
    id: 2,
    name: '运营管理员',
    description: '负责用户管理、租户管理、订单管理等运营相关功能',
    userCount: 8,
    permissions: ['overview', 'users-list:view', 'users-list:add', 'users-list:edit', 'users-list:export', 'tenants-list:view', 'tenants-list:add', 'tenants-list:edit', 'tenants-list:export', 'orders-list:view', 'orders-list:edit', 'orders-list:export', 'orders-after-sales:view', 'orders-after-sales:edit', 'points-operations:view', 'points-operations:add', 'points-operations:export', 'points-recharge:view', 'points-recharge:add', 'notifications-list:view', 'notifications-list:add', 'notifications-list:edit', 'notifications-records:view'],
    status: true,
    createdAt: '2024-01-20 14:22:18',
  },
  {
    id: 3,
    name: '技术管理员',
    description: '负责资源管理、系统配置、监测等技术相关功能',
    userCount: 5,
    permissions: ['overview', 'resources-servers:view', 'resources-servers:add', 'resources-servers:edit', 'resources-servers:delete', 'resources-templates:view', 'resources-templates:add', 'resources-templates:edit', 'resources-templates:delete', 'resources-datacenters:view', 'resources-datacenters:add', 'resources-datacenters:edit', 'resources-datacenters:delete', 'resources-apps:view', 'resources-apps:add', 'resources-apps:edit', 'resources-apps:delete', 'monitoring-faults:view', 'monitoring-faults:edit', 'user-resources-cloud-pcs:view', 'user-resources-cloud-pcs:edit', 'user-resources-cloud-pcs:delete', 'user-resources-cloud-disks:view', 'user-resources-cloud-disks:edit', 'user-resources-cloud-disks:delete', 'terminals-venues:view', 'terminals-venues:add', 'terminals-venues:edit', 'terminals-venues:delete', 'terminals-thin-clients:view', 'terminals-thin-clients:add', 'terminals-thin-clients:edit', 'terminals-thin-clients:delete', 'system-logs:view', 'system-logs:export', 'system-config:view', 'system-config:edit', 'system-maintenance:view', 'system-maintenance:edit', 'system-tasks:view', 'system-tasks:add', 'system-tasks:edit', 'system-tasks:delete'],
    status: true,
    createdAt: '2024-02-01 09:15:42',
  },
  {
    id: 4,
    name: '商品管理员',
    description: '负责商品管理、分类管理等商品相关功能',
    userCount: 4,
    permissions: ['overview', 'products-list:view', 'products-list:add', 'products-list:edit', 'products-list:delete', 'products-list:export', 'products-disks:view', 'products-disks:add', 'products-disks:edit', 'products-disks:delete', 'products-recharge:view', 'products-recharge:add', 'products-recharge:edit', 'products-recharge:delete', 'products-categories:view', 'products-categories:add', 'products-categories:edit', 'products-categories:delete', 'orders-list:view', 'orders-list:export'],
    status: true,
    createdAt: '2024-02-10 16:45:33',
  },
  {
    id: 5,
    name: '客服专员',
    description: '负责查看用户信息、处理售后订单等客服相关功能',
    userCount: 12,
    permissions: ['overview', 'users-list:view', 'tenants-list:view', 'orders-list:view', 'orders-after-sales:view', 'orders-after-sales:edit', 'notifications-list:view', 'notifications-records:view'],
    status: true,
    createdAt: '2024-02-15 11:20:56',
  },
  {
    id: 6,
    name: '财务专员',
    description: '负责账单管理、充值管理等财务相关功能',
    userCount: 3,
    permissions: ['overview', 'products-recharge:view', 'products-recharge:add', 'orders-list:view', 'orders-list:export', 'points-operations:view', 'points-operations:export', 'points-recharge:view', 'points-recharge:add', 'billing-management:view', 'billing-management:export'],
    status: true,
    createdAt: '2024-02-20 13:38:27',
  },
  {
    id: 7,
    name: '只读用户',
    description: '只能查看数据，无任何编辑权限',
    userCount: 6,
    permissions: ['overview', 'users-list:view', 'tenants-list:view', 'resources-servers:view', 'resources-templates:view', 'resources-datacenters:view', 'resources-apps:view', 'monitoring-faults:view', 'products-list:view', 'products-disks:view', 'products-recharge:view', 'products-categories:view', 'orders-list:view', 'orders-after-sales:view', 'points-operations:view', 'user-resources-cloud-pcs:view', 'user-resources-cloud-disks:view', 'terminals-venues:view', 'terminals-thin-clients:view', 'billing-management:view', 'notifications-list:view', 'notifications-records:view', 'system-logs:view'],
    status: true,
    createdAt: '2024-03-01 10:12:45',
  },
  {
    id: 8,
    name: '测试角色',
    description: '用于测试的角色，当前已禁用',
    userCount: 0,
    permissions: ['overview'],
    status: false,
    createdAt: '2024-03-05 15:28:19',
  },
];
